import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ContractAssociationDto, FinalizeContractAssociationInputDto, FomentContractAssociationDto, GetStandCycleRotationsForAssociationInputDto, StandCycleRotationAssociationDto } from '../dtos/contract-association/models';
import type { ContractQueryInputDto, GetFomentContractsInputDto } from '../dtos/integrations/bio-forest-abp/models';

@Injectable({
  providedIn: 'root',
})
export class ContractAssociationOrchestratorService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  finalizeContractAssociation = (input: FinalizeContractAssociationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/orchestrator/planning/contract-association/finalize',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  getContractsAssociationByInput = (input: ContractQueryInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ContractAssociationDto>>({
      method: 'GET',
      url: '/api/orchestrator/planning/contract-association/contracts-by-vendor-id',
      params: { contractTypeId: input.contractTypeId, contractTypeGroupId: input.contractTypeGroupId, contractMasterGroupCode: input.contractMasterGroupCode, number: input.number, fomentContractId: input.fomentContractId, vendorId: input.vendorId, isActive: input.isActive, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getFomentContractsAssociation = (input: GetFomentContractsInputDto, cancellationToken?: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<FomentContractAssociationDto>>({
      method: 'GET',
      url: '/api/orchestrator/planning/contract-association/foment-contracts-by-vendor-id',
      params: { vendorId: input.vendorId, number: input.number, ids: input.ids, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getStandCycleRotations = (input: GetStandCycleRotationsForAssociationInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandCycleRotationAssociationDto>>({
      method: 'GET',
      url: '/api/orchestrator/planning/contract-association/stand-cycle-rotations-by-property-id',
      params: { propertyId: input.propertyId, filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
}